import { useCallback, useMemo } from 'react';
import { initiatePasskey, validatePasskey } from '../data/passkeys';
export const arrayBufferToBase64 = arrayBuffer => btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));
export const usePasskeyValidation = ({
  onSuccess,
  onClose,
  handleError
}) => {
  const getPublicKey = async publicKeyCredentialRequestOptions => {
    // Transform the public key to the expected data types expected by navigator.credentials.create
    const publicKey = Object.assign({}, publicKeyCredentialRequestOptions, {
      challenge: Uint8Array.from(publicKeyCredentialRequestOptions.challenge, letter => letter.charCodeAt(0))
    });

    // eslint-disable-next-line compat/compat
    return await navigator.credentials.get({
      publicKey
    });
  };
  const validateWithPasskey = useCallback(async email => {
    try {
      const initiateResponse = await initiatePasskey(email);
      const publicKeyCredential = await getPublicKey(initiateResponse);
      const authenticatorResponse = publicKeyCredential.response;
      const transformedPublicKey = {
        rawId: arrayBufferToBase64(publicKeyCredential.rawId),
        response: {
          authenticatorData: arrayBufferToBase64(authenticatorResponse.authenticatorData),
          clientDataJSON: arrayBufferToBase64(authenticatorResponse.clientDataJSON),
          signature: arrayBufferToBase64(authenticatorResponse.signature),
          userHandle: authenticatorResponse.userHandle ? arrayBufferToBase64(authenticatorResponse.userHandle) : authenticatorResponse.userHandle
        },
        id: publicKeyCredential.id,
        type: publicKeyCredential.type
      };
      const validateResponse = await validatePasskey({
        publicKeyValidationCredential: transformedPublicKey,
        publicKeyCredentialRequestOptions: initiateResponse,
        userEmail: email
      });
      if (!validateResponse || Object.keys(validateResponse).length === 0) {
        onClose();
        onSuccess();
      } else {
        throw new Error();
      }
    } catch (_unused) {
      handleError();
    }
  }, [onClose, onSuccess, handleError]);
  return useMemo(() => ({
    validateWithPasskey
  }), [validateWithPasskey]);
};